import React from 'react';
import Icon from '../atoms/Icon';

function SortArrowIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox='0 0 9 12'>
      <g
        stroke='currentColor'
        fill='none'
        fillRule='evenodd'
      >
        <path d='M4.36023 10.7556V0M8.36023 6.84444L4.36023 11L0.360229 6.84444'/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(SortArrowIcon);
